import { LoginContext } from "./LoginContext";
import { useCommon } from "./useLogin";

const LoginProvider = ({ children }: any) => {
  const value = useCommon();
  return (
    <LoginContext.Provider value={value}>{children}</LoginContext.Provider>
  );
};

export default LoginProvider;
